<template>
    <ul class="actions">
        <!-- <li class="actions__action">
            <a :href="productUrl" class="button button--1 js-show-options">
                View
            </a>
        </li> -->
        <li class="actions__action">
            <button type="button" class="button button--2" :class="{'is-open': isOpen}" @click="isOpen = !isOpen" style="margin: 1rem 0 0">
                Add
            </button>
        </li>
    </ul>
    <div class="form-inner" :style="{ display: isOpen ? 'block' : 'none' }">

        <div v-if="purchasables.length > 1" class="frm-row">
            <label>Type</label>
            <select class="selectBox" v-model="selectedPurchasable">
                <option :value="null" disabled>Choose type</option>
                <option v-for="(purchasable, idx) in purchasables" :key="purchasable.id || idx" :value="purchasable">
                    {{ purchasable.name }} - £{{ purchasable.price.toFixed(2) }}
                </option>
            </select>
        </div>

        <p class="label">Quantity/Delivery day(s)</p>

        <ProductControls 
            :purchasable="effectivePurchasable" 
            :include-day-labels="true"
            :include-clear-button="true"
            :include-add-to-quote-button="true"
            :dynamically-update-basket-store="false"
        />

        <!-- <p class="prod-subtotal">Sub total: <span>£{{ subTotal.toFixed(2) }}</span></p> -->
    </div>

    <a class="more-info" :href="productUrl">Product Information</a>

    <Modal :id="effectivePurchasable ? effectivePurchasable.name : ''">
        <ModalContentProductAddedToBasket 
            :lineDescription="effectivePurchasable ? effectivePurchasable.name : ''"
            :icon="effectivePurchasable && effectivePurchasable.categoryIcon ? effectivePurchasable.categoryIcon : undefined"
            :hideButtons="true"
            @close="$emit('close')" 
        />
    </Modal>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import { useBasketStore } from './store';
    import ProductControls from './ProductControls.vue';
    import Modal from './Modal.vue';
    import ModalContentProductAddedToBasket from './ModalContentProductAddedToBasket.vue';

    const basketStore = useBasketStore();

    const props = defineProps({
        purchasables: {
            type: Array,
            required: true
        },
        productUrl: {
            type: String,
            required: false,
            default: ''
        }
    });

    const isOpen = ref(false);

    // Default to null so the placeholder is selected until a real purchasable is chosen
    const selectedPurchasable = ref(null);

    const effectivePurchasable = computed(() => {
        return props.purchasables && props.purchasables.length === 1
            ? props.purchasables[0]
            : selectedPurchasable.value;
    });

    const subTotal = computed(() => {
        if (!effectivePurchasable.value) return 0;
        const items = basketStore.items.filter(item => item.id === effectivePurchasable.value.id);
        return items.reduce((subTotal, item) => subTotal + basketStore.lineItemSubtotal(item), 0);
    });

    watch(() => props.purchasables, (newPurchasables) => {
        if (!newPurchasables || newPurchasables.length === 0) {
            selectedPurchasable.value = null;
            return;
        }

        // Only manage the manual selection when there are multiple options
        if (newPurchasables.length > 1 && selectedPurchasable.value) {
            const isStillValid = newPurchasables.some(p => p.id === selectedPurchasable.value.id);
            if (!isStillValid) {
                selectedPurchasable.value = null;
            }
        }
    });
</script>

<style scoped>
    .prod-subtotal {
        min-height: 0 !important;
        margin: 1rem 0;
    }

    .actions {
        margin: 0;
    }

    .form-inner {
        padding: 1rem;
        background: #eee;
    }

    .product-controls {
        width: 100%;
        max-width: none;
    }

    .row--products .col.product select.selectBox {
        width: 100%;
        border: none;
        padding: 10px;
        height: auto;
        appearance: none;
        background-color: #fff;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/></svg>');
        background-repeat: no-repeat;
        background-position: right 10px center;
    }
    .row--products .col.product label {
        margin: 0 1rem 0 0;
    }

    .row--products .col.product .frm-row {
        display: flex;
        align-items: baseline;
    }

    .is-open {
        border-radius: 4px 4px 0 0;
    }

    .more-info {
        display: block;
        margin-top: 1rem;
        color: #488684;
        text-decoration: underline;
    }

    .button {
        position: relative;
    }

    .button::after {
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/></svg>');
        filter: brightness(0) invert(1);
        position: absolute;
        right: 1rem;
        height: 18px;
        top:50%;
        transform: translateY(-50%);
    }

    .button.is-open::after {
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/></svg>');
        height: 18px;
        top:50%;
        transform: translateY(-50%);
    }
</style>